module.exports = __webpack_public_path__ + "static/media/tax.b3576ead.jpg";